// import './index.scss';
import React, { useEffect, useState } from 'react';
import Logo from "../../components/general/logo"
import qs from 'qs';
import {
    AutoComplete,
    Button,
    DatePicker,
    Checkbox,
    Col,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
    message,
} from 'antd';

import { BaseUrlAuth } from '../../utils';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { errorHandling } from '../../utils/helper';
const passwordRules: object[] = [
    {
        required: true,
        message: 'Please input your password!',
    },
];


const ResetPassword: React.FC = (): JSX.Element => {

    const [searchParams] = useSearchParams();
    const [message, setMessage] = useState<string>();
    const [form] = Form.useForm();
    const [authData, setAuthData] = useState<any>({
        password: '',
    });

    const handleAuthDataChange = (e: any) => {
        setAuthData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = () => {
        axios
            .post(BaseUrlAuth + `/api/v1/auth/reset-password`, { ...authData, token: searchParams.get("reset_token") }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((res) => {
                setMessage("Password reset successful!");
            })
            .catch((error) => {
                if (error.response.status === 400) {
                    setMessage("Try again!")
                }
                else {
                    setMessage("Invalid token!Try again!");
                }
            });

    }

    return (
        <div className="signin-page">
            <div style={{ marginTop: '25vh' }}>
                <Logo {...{ size: 'large' }} />
            </div>
            <Form
                form={form}
                name="register"
                onFinish={handleSubmit}
                scrollToFirstError
            >
                <div className="container-xxl signup-container">
                    <div className="row custom-row">
                        <div className="col">
                            <Form.Item
                                name="password"
                                className="input-field"
                                label=""
                                rules={passwordRules}
                            >
                                <Input.Password
                                    placeholder="Password"
                                    className="input-password"
                                    name="password"
                                    onChange={handleAuthDataChange}
                                />
                            </Form.Item>
                        </div>
                        <div className="col">
                            <Form.Item
                                name="confirm"
                                label=""
                                className="input-field"
                                dependencies={['password']}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please confirm your password!',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(
                                                new Error(
                                                    'The two passwords that you entered do not match!'
                                                )
                                            );
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password
                                    className="input-password"
                                    placeholder="Confirm Password"
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <p style={{ color: 'red' }}>{message}</p>
                    <div className="row custom-row">
                        <div className="col">
                            <Form.Item
                                className="input-field Sign-Up-Button"
                                style={{ paddingTop: '10px' }}
                            >
                                <Button type="primary" htmlType="submit">
                                    Reset Password
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </Form>

        </div>
    );
};

export default ResetPassword;
